import { Palette } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";

const FONT_FAMILY = `"Poppins","Roboto","Helvetica","Arial",sans-serif`;

export const typography: (palette: Palette) => TypographyOptions = () => ({
  allVariants: {
    fontFamily: FONT_FAMILY
  },
  body1: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5
  },
  body2: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.5
  },
  h1: {
    fontSize: 26,
    fontWeight: 600,
    lineHeight: "36px"
  },
  h2: {
    fontSize: 22,
    fontWeight: 600,
    lineHeight: 1.3
  },
  h3: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: "30px"
  },
  h4: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "27px"
  },
  h5: {
    fontSize: 16,
    fontWeight: 600
  },
  h6: {
    fontSize: 13,
    fontWeight: 500
  },
  subtitle1: {
    fontSize: 12,
    fontWeight: 400
  },
  subtitle2: {
    fontSize: 13,
    fontWeight: 500
  },
  caption: {
    fontSize: 12,
    fontWeight: 400
  },
  button: {
    fontFamily: FONT_FAMILY,
    fontWeight: 500,
    textTransform: "none"
  }
});

export default typography;
